
export const API_URL = 'https://gliaco.azurewebsites.net'
//export const API_URL = 'http://localhost:5271'